import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import '../css/CurrentCars.css';
import '../css/Sidebar.css';
import '../css/Navbar.css';
import { FaArchive } from "react-icons/fa";
import { authAPI, vehiclesAPI } from '../api/api';
import { usePermissions } from '../hooks/usePermissions';

const ArchiveCars = ({ isSidebarClosed, setIsSidebarClosed }) => {
  const { permissions } = usePermissions();
  
  const allFields = [
    { key: 'chassis_number', label: 'Alvázszám' },
    { key: 'plate_number', label: 'Rendszám' },
    { key: 'handover', label: 'Átadás' },
    { key: 'handoff', label: 'Leadás' },
    ...(permissions?.can_see_rental_fee ? [{ key: 'rentalFee', label: 'Bérköltség' }] : []),
    { key: 'monthly_distance', label: 'Futás' },
  ];

  const [archivedCars, setArchivedCars] = useState([]);
  const [visibleFields, setVisibleFields] = useState(allFields.map(f => f.key));
  const [search, setSearch] = useState('');
  const [sortField, setSortField] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');

  const user = authAPI.getCurrentUser();

  useEffect(() => {
    const loadArchivedCars = async () => {
      try {
        if (!user) {
          console.warn('Nincs bejelentkezett felhasználó');
          setArchivedCars([]);
          return;
        }

        const carsData = await vehiclesAPI.getAllVehiclesForUser();
        const archived = carsData.filter(car => car.status === 'info');
        setArchivedCars(archived);
      } catch (error) {
        console.error('Hiba az archív autók betöltésekor:', error);
        setArchivedCars([]);
      }
    };

    loadArchivedCars();
  }, [user?.id]);

  useEffect(() => {
    document.body.classList.add('cars-bg');
    return () => document.body.classList.remove('cars-bg');
  }, []);

  let carsToShow = archivedCars;
  if (search) {
    const s = search.toLowerCase();
    carsToShow = carsToShow.filter(car =>
      car.chassis_number.toLowerCase().includes(s) ||
              car.plate_number.toLowerCase().includes(s) ||
      car.model.toLowerCase().includes(s) ||
      car.owner.toLowerCase().includes(s)
    );
  }
  if (sortField) {
    carsToShow = [...carsToShow].sort((a, b) => {
      let aVal = a[sortField] || '';
      let bVal = b[sortField] || '';
      if (sortField === 'monthly_distance') {
        aVal = parseInt((aVal || '').replace(/[^0-9]/g, '')) || 0;
        bVal = parseInt((bVal || '').replace(/[^0-9]/g, '')) || 0;
      }
      if (aVal < bVal) return sortDirection === 'asc' ? -1 : 1;
      if (aVal > bVal) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
  }

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(dir => dir === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  return (
    <>
      <Navbar isSidebarClosed={isSidebarClosed} setIsSidebarClosed={setIsSidebarClosed} />
      <Sidebar isCollapsed={isSidebarClosed} setIsCollapsed={setIsSidebarClosed} />
      <div className="page-content">
        <h2>Archív autók</h2>
        <div className="home-table-header-row">
           <div className="home-table-header"> </div>
          {allFields.map((field) => (
            visibleFields.includes(field.key) && (
              <div
                className="home-table-header-cell"
                key={field.key}
                onClick={() => handleSort(field.key)}
                style={{ cursor: 'pointer', userSelect: 'none', fontWeight: sortField === field.key ? 'bold' : undefined }}
              >
                {field.label}
                {sortField === field.key && (
                  <span style={{ marginLeft: 4 }}>{sortDirection === 'asc' ? '▲' : '▼'}</span>
                )}
              </div>
            )
          ))}
        </div>
        {carsToShow.length === 0 && <div style={{margin: 16}}>Nincs archív autó.</div>}
        {carsToShow.map((car, idx) => (
          <div className="car-card" key={idx} style={{display:'flex',flexDirection:'row',position:'relative'}}>
            <div className="car-card-imgwrap" style={{display:'flex',alignItems:'center',justifyContent:'center',minWidth:'130px',maxWidth:'130px',height:'100%',background:'var(--color-bg-light-dark)'}}>
              <img src={car.gallery && car.gallery[0]} alt={car.model} className="car-card-img" />
            </div>
            <div style={{flex:1,display:'flex',flexDirection:'column'}}>
              <div className="car-card-row1">
                {visibleFields.includes('chassis_number') && (
                  <div className="car-card-cell vin" style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                    <span className='cell_span'>Alvázszám</span>
                    {car.chassis_number17}
                  </div>
                )}
                {visibleFields.includes('plate_number') && (
                  <div className="car-card-cell plate" style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                    <span className='cell_span'>Rendszám</span>
                    {car.plate_number}
                  </div>
                )}
                {visibleFields.includes('handover') && (
                  <div className="car-card-cell handover" style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                    <span className='cell_span'>Átadás</span>
                    {car.handover}
                  </div>
                )}
                {visibleFields.includes('rentalFee') && (
                  <div className="car-card-cell rentalFee" style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                    <span className='cell_span'>Bérleti díj (/hó)</span>
                    {car.rentalFee || '-'}
                  </div>
                )}
                {visibleFields.includes('monthly_distance') && (
                  <div className="car-card-cell futas" style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
                    <span className='cell_span'>Futás</span>
                    {car.monthly_distance}
                  </div>
                )}
              </div>
              <div className="car-row-divider" style={{marginLeft:0,width:'100%'}}></div>
              <div className="car-card-row2">
                <div className="car-card-badges">
                  <span className="car-card-badge owner">{car.owner}</span>
                  <span className="car-card-badge highway">Autópálya matrica: {car.highway_ticket}</span>
                </div>
                <div className="car-card-status">
                  <span className="car-status-info">Archív</span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ArchiveCars; 